const t = {
  "text-link": "text-link",
  "text-link__link": "text-link__link",
  "text-link__icon-container": "text-link__icon-container",
  "text-link__text": "text-link__text",
  "text-link__visually-hidden": "text-link__visually-hidden",
  "text-link--footnote": "text-link--footnote",
  "text-link--contact-person": "text-link--contact-person",
  "text-link--footer-social": "text-link--footer-social",
  "text-link--footer-column": "text-link--footer-column",
  "text-link--footer-quick": "text-link--footer-quick",
  "text-link--footer-service": "text-link--footer-service",
  "text-link--breadcrumbs": "text-link--breadcrumbs",
  "text-link--news-page": "text-link--news-page",
  "icon-container": "icon-container",
  "text-link--responsive-table": "text-link--responsive-table"
};
export {
  t as default
};
